uniform vec2 uScale;
uniform float uBend; // 0=平面，1=完全沿弧彎曲
uniform float uBendRadius; // 彎曲半徑（與 Carousel 的弧半徑 R 相同 → 整片貼合大弧）

varying vec2 vUv;

void main() {
    vUv = uv;

    vec3 p = position;

    // 沿自身局部 X 把平面彎成半徑 uBendRadius 的弧（中心朝 -Z = 大弧圓心方向）。
    // position.x ∈ [-0.5, 0.5]，乘 uScale.x 還原世界寬度；x 再除 uScale.x 抵銷 model 矩陣縮放，
    // z 不被縮放（scale.z=1）所以直接給世界深度。中心點(x=0)維持在原點 → 卡片中心仍落在弧上。
    if (uBend > 0.0001) {
        float w = uScale.x;
        float theta = (position.x * w) / uBendRadius;
        vec3 curved = vec3(
            uBendRadius * sin(theta) / w,
            position.y,
            uBendRadius * cos(theta) - uBendRadius
        );
        p = mix(p, curved, uBend);
    }

    gl_Position = projectionMatrix * modelViewMatrix * vec4(p, 1.0);
}
